import type {
  AppThunkAction,
  AppThunkDispatch
} from '@console/actions/thunkType';
import GiftCardPreview from '@console/components/common/GiftCardPreview';
import type { AppState } from '@console/reducers';
import {
  getGiftCardTicketsForPreview,
  getGiftWalletStorableForPreview,
  getMessageCardForPreview
} from '@console/selectors/projectDetail/giftCardForPreview';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  header: state.defaultGiftCardConfig.header,
  footer: state.defaultGiftCardConfig.footer,
  messageCard: getMessageCardForPreview(state),
  giftCardTickets: getGiftCardTicketsForPreview(state),
  giftWalletStorable: getGiftWalletStorableForPreview(state)
});

const handleTicketClick = (): AppThunkAction<void> => () => {};

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  handleTicketClick: () => dispatch(handleTicketClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardPreview);
